/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import history from 'navigation/history';

const useScript = (url, pathname) => {
  useEffect(() => {
    const script = document.createElement('script');

    if (window.location.pathname === pathname || !pathname) addScriptOnHead(script, url);

    history.listen((location) => {
      if (location.pathname === pathname || !pathname) {
        addScriptOnHead(script, url);
      } else {
        removeScriptOnHead(script);
      }
    });
  }, [url, pathname]);

  function addScriptOnHead(script, url) {
    script.src = url;
    script.async = true;
    script.crossorigin = 'anonymous';

    document.head.appendChild(script);
  }

  function removeScriptOnHead(script) {
    setTimeout(() => {
      if (script && script.src === url) {
        document.head.removeChild(script);
        window.location.reload();
      }
    }, 500);
  }
};

export default useScript;
